<template>
  <div
    ref="containerRef"
    class="accordion-screen__container"
  >
    <Accordion
      :active-index="activeIndex"
      @tab-close="handleMinify(true)"
      @tab-open="handleMinify(false)"
    >
      <AccordionTab :header="route.meta.title">
        <template #header>
          <span
            v-if="route?.meta?.materialIcon"
            class="material-icons menu-item__icon tab-header-icon"
          >
            {{ route.meta.materialIcon }}
          </span>
          <span
            v-if="route?.meta?.primeIcon"
            :class="primeIconClasses"
          >
            {{ route.meta.materialIcon }}
          </span>
        </template>
        <div class="accordion-screen__content-container">
          <slot />
        </div>
      </AccordionTab>
    </Accordion>
  </div>
</template>

<script setup>
import {ref, computed, onBeforeMount} from 'vue';
import {useStore} from 'vuex';
import {useRoute} from 'vue-router';
import {onClickOutside} from '@vueuse/core';

import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
// #region Props, Emits

// #endregion

// #region Params, Ref, Reactives, Computed
const store = useStore();
const route = useRoute();
const activeIndex = ref(0);

const containerRef = ref();

const primeIconClasses = computed(() => {
  if (route?.meta?.primeIcon) {
    return 'menu-item__icon tab-header-icon pi pi-' + route.meta.primeIcon;
  }
  return null;
});
// #endregion

// #region Functions
const handleMinify =
  (async (status) => {
    await store.dispatch('app/setOverlayMinification', status);
    if (!!status) { // Hide accordion
      activeIndex.value = Math.random() * -1; // Random so it changes and always emits updated event
    }
  });
async function goCoordinates({coordinates, name, visible, zoom}) {
  const showName = !!visible ? '' : name;
  await store.dispatch('userLayers/cleanMarkerLayers');
  await handleMinify(true);
  await store.dispatch(
    'userLayers/addMarkerLayer',
    {coordinates, name: showName, iconUrl: ''},
    {root: true},
  );
  await store.dispatch(
    'map/setCenter',
    {center: coordinates},
    {root: true},
  );
  await store.dispatch('map/setZoom', {zoom}, {root: true});
}
// #endregion

// #region Effects, Hooks
onBeforeMount(async () => {
  await handleMinify(false);
});
const insideElementsList =
  [
    '.p-dropdown-panel',
    '.p-multiselect-panel',
    '.p-toast',
    '#toasts-custom-scroll',
    '.modal',
    '.modalPhoto',
    '.app__footer',
    '.p-autocomplete-panel',
  ];
onClickOutside(containerRef, () => handleMinify(true), {ignore: insideElementsList});
// #endregion

// #region Provide, Expose
defineExpose({
  handleMinify,
  goCoordinates,
});
// #endregion
</script>
<style lang="scss" scoped>
@import "@/styles/custom-colors.scss";
.accordion-screen {
  &__container {
    & :deep(a.p-accordion-header-link) {
      border: none;
      text-align: center;
      display: block;
    }
    & :deep(a.p-accordion-toggle-icon) {
      display: hidden;
    }
    & :deep(div.p-accordion-header) {
      border: none;
      margin: 0 auto;
    }
    & :deep(div.p-accordion-content) {
      border: none;
    }
  }
  &__content-container {
    overflow-y: auto;
  }
}
.tab-header-icon {
  color: $solid-blue;
  font-size: 1.5rem;
  margin-left: 10px;
  position: absolute;
  top: .85rem;
  right: 3.6rem;
}
</style>
